// extracted by mini-css-extract-plugin
export default {"container":"CustomBreadcrumbs_container__1hI3C","text":"CustomBreadcrumbs_text__r8e-I"};